export default __webpack_public_path__ + "static/media/IC00054-contact.25883645.svg";